import React, { useEffect, useState } from "react";

import { useAppDispatch } from "../../../../../../store/Hooks";

import SelectForm from "../../../../../common/controls/SelectForm";

import { filterList } from "../../../../../../services/tabs.service";
import { omit } from "lodash";

const Manufacturer: React.FC<any> = (props: any) => {
  const {
    manufacturers,
    listFiltered,
    setIsFilteredList,
    manufacturer,
    setFilterValue,
    originalList,
    filters,
    sort,
    placeholder,
    removeFilter
  } = props;

  const dispatch = useAppDispatch();

  const [localValue, setLocalValue] = useState(null);

  useEffect(() => {
    setLocalValue(manufacturer);
  }, [manufacturer]);

  /**
   * Handles onChange
   */
  const handleOnChange = async (key: string, value: string) => {
    if (value && value !== "") {
      setFilterValue(key, value);

      let filtersObject = { ...filters };

      filtersObject[key] = {
        sign: "=",
        value
      };

      const filtered = await filterList(originalList, filtersObject, sort);

      dispatch({
        type: listFiltered.type,
        payload: filtered
      });

      dispatch({
        type: setIsFilteredList.type,
        payload: true
      });
    }
  };

  const clearValue = async () => {
    const key = "manufacturer";
    let filtered: any;
    removeFilter(key);

    let temp = { ...filters };

    if (temp[key]) {
      temp = omit(temp, [key]);
    }

    if (Object.keys(temp).length > 0) {
      filtered = await filterList(originalList, temp, sort);
    } else {
      filtered = originalList;

      dispatch({
        type: setIsFilteredList.type,
        payload: false
      });
    }

    dispatch({
      type: listFiltered.type,
      payload: filtered
    });
  };

  return (
    <SelectForm
      label="Manufacturer"
      options={manufacturers}
      name="manufacturer"
      onChange={handleOnChange}
      value={localValue && localValue}
      placeholder={placeholder}
      clearValue={clearValue}
    />
  );
};

export default Manufacturer;
